import { createSelector } from 'reselect';
import { enabledSelector } from 'selectors/testTarget/offers/smartSkinScanBanner/enabled/enabledSelector';
import { placementSelector } from 'selectors/testTarget/offers/smartSkinScanBanner/placement/placementSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showSmartSkinScanBannerSelector = createSelector(
    isTestTargetReadySelector,
    enabledSelector,
    placementSelector,
    (testReady, enabled, placement) => ({
        enabled: testReady && enabled === true,
        placement: testReady ? placement : 'none'
    })
);

export { showSmartSkinScanBannerSelector };
